export const normalizeLayoutHeader = (rawData) => {
  const {
    z_order: zOrder = '0',
    bg_img_landscape: bgImgLandscape = '',
    bg_img_portrait: bgImgPortrait = '',
    tag_img: tagImg = '',
    title_img: titleImg = '',
    title_list: titleList = [],
    alt = '',
  } = rawData

  return {
    zOrder,
    bgImgLandscape,
    bgImgPortrait,
    tagImg,
    titleImg,
    titleList,
    alt,
  }
}
